// Import dependencies
import React from 'react';
import axios from 'axios';
// import ReactHtmlParser from 'react-html-parser';

// Import components
import Spinner from '../../../reusables/spinner';

// Import styling
import './LandingPage.css';

// Import config
import config from '../../../../configs/config.json';
const API_URL = config.API_URL;


class TestLandingPage extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            headerHTML: '',
            newRecordings: '',
            catalog: [],
            dataLoaded: false,
        }
    }

    componentDidMount = () => {
        axios.get(`${API_URL}/landing/`)
        .then(response => {
            var payload = response.data;
            console.log("Landing Meta: ", payload);

            if(payload.success) {
                var catalog = payload.courseCatalog.filter((course) => course.display === 1);
                this.setState({
                    headerHTML: payload.headerHTML,
                    newRecordings: payload.newRecordings.text,
                    catalog,
                    dataLoaded: true
                });
            }
        })
        .catch(error => { 
            console.log(error);
        });
    }

    buildCourseEntry = (entry, key) => {
        // Render each course entry as it's own column
        var imageURL = `/images/${entry.link}`;

        return (
            
            
            <div key={key} className='col-lg-4 col-md-4 col-sm-12 col-xs-12 CourseListing'>
                <img className="card-img-top" src={imageURL} alt='Course Thumbnail' />
                
                <div className='card-text'>
                    
                    {entry.description.split('\n').map((line, index) => {
                        return <p key={index}>{line}</p>
                    })}
                    
                </div>
            </div>
        )
    }

    render() {
        // var parsedHeaderHTML = ReactHtmlParser(this.state.headerHTML);
        // var parsedMidSectionHTML = ReactHtmlParser(this.state.newRecordings);

        if(this.state.dataLoaded === false) {
            return (
                <div> <Spinner /> </div>
            )
        } else {

            var remainingArray = this.state.catalog.slice(1);
            console.log(remainingArray);

            return (
              <div className="landing-page">
                <nav className="d-flex position-relative" id="lp-nav">
                  <a className="btn rounded-0 flex-grow-1 flex-fill" target="_blank" rel="noreferrer" aria-label="OLLI Homepage (opens new window)" href="https://ce.uci.edu/olli">OLLI Homepage</a>
                  <a className="btn rounded-0 flex-grow-1 flex-fill" target="_blank" rel="noreferrer" aria-label="View Courses (opens new window)" href="https://ce.uci.edu/olli/courses">View Courses</a>
                  <a className="btn rounded-0 flex-grow-1 flex-fill" target="_blank" rel="noreferrer" aria-label="Help (opens new window)" href="https://olliuci.wordpress.com/orlc/">Help</a>
                </nav>
                <div id="main-content" style={{ backgroundColor: 'white', height: '1px' }}></div>
                <div className="row">
                  <div className="responsive-flex-wrapper">
                    <div id="leftside">
                      <span className="image-fit">
                        <img src="/images/testgroup.jpg" alt="Group of students viewing a presentation" />
                      </span>
                    </div>
                    <div id="rightside">
                      <div id="topdivider"></div>
                      <h2 className="text-dark font-weight-bold">Welcome New and Returning Members</h2>
                      <div className="button-container">
                        <button className="rounded-button-single btn btn-primary" onClick={() => window.location.href = '/login'}>Log In</button>
                        <button className="rounded-button-single btn btn-warning" onClick={() => window.location.href = '/register'}>Sign Up</button>
                      </div>
                    </div>
                    <div id="middleside"></div>
                  </div>
                </div>
                <div className="row">
                    <div style={{ paddingTop: 10, paddingBottom: 10 }} id="middivider">
                            <span className="midtext">
                                Upcoming Classes
                            </span>
                    </div>
                </div>
                <div className="thumbnail-container">
                  <div className="thumbnail-row">
                    <div className="thumbnail-single"><div className="thumbnail-picture" id="olli-course-1"><img src="/images/fp-1.png" alt="Class 1" /></div></div>
                    <div className="thumbnail-single"><div className="thumbnail-picture" id="olli-course-2"><img src="/images/fp-2.png" alt="Class 2" /></div></div>
                    <div className="thumbnail-single"><div className="thumbnail-picture" id="olli-course-3"><img src="/images/fp-3.png" alt="Class 3" /></div></div>
                    <div className="thumbnail-single"><div className="thumbnail-picture" id="olli-course-4"><img src="/images/fp-4.png" alt="Class 4" /></div></div>
                    <div className="thumbnail-single"><div className="thumbnail-picture" id="olli-course-5"><img src="/images/fp-5.png" alt="Class 5" /></div></div>
                    <div className="thumbnail-single"><div className="thumbnail-picture" id="olli-course-6"><img src="/images/fp-6.png" alt="Class 6" /></div></div>
                  </div>
                </div>
                <div style={{ paddingTop: 10, paddingBottom: 10 }} className="button-row">      
                     <div className="button-container">
                        <button className="rounded-button-single btn btn-primary" onClick={() => window.open('https://ce.uci.edu/olli/courses', '_blank')}>View All Courses</button>
                    </div>
                </div>
                <div id="footer">
                    <div className="image-footer">
                        <img src="/images/ridethewave.png" alt="" aria-hidden="true" />
                    </div>
                </div>
            </div>
            )
        }
    }
};

export default TestLandingPage;
